import Icon from "@ant-design/icons/lib/components/Icon";

const LocationSVG = () => (
    <svg
        width="22"
        height="27"
        viewBox="0 0 22 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11 25C11 25 21 16.6522 21 10.3913C21 5.20463 16.5228 1 11 1C5.47715 1 1 5.20463 1 10.3913C1 16.6522 11 25 11 25Z"
            stroke="#FECC7B"
            stroke-width="2"
        />
        <path
            d="M14.1949 10.0002C14.1949 11.657 12.7647 13.0002 11.0004 13.0002C9.23617 13.0002 7.80596 11.657 7.80596 10.0002C7.80596 8.34334 9.23617 7.00019 11.0004 7.00019C12.7647 7.00019 14.1949 8.34334 14.1949 10.0002Z"
            stroke="#FECC7B"
            stroke-width="2"
        />
    </svg>
);

export const Location = (props) => <Icon component={LocationSVG} {...props} />;
